const SIZES = {
  SMALL: 12,
  MEDIUM: 24,
  LARGE: 36,
};
export { SIZES };

export default SIZES;
